import mobx, {observable, action, computed} from 'mobx';
import Address from "../Address";
import Settings from "../Settings";
import Aircraft from "../Aircraft";
import FlightRoute from "../Flight/FlightRoute";
import moment from 'moment-timezone';
import BackendFactory from "../../Services/BackendFactory";
import FlightRoutePoint from "../Flight/FlightRoutePoint";

export default class FlightRequestRequest {

  @observable first_name: string;
  @observable last_name: string;
  @observable email: string;
  @observable phone: string;
  @observable note: string;
  @observable aircraft_model: Aircraft = null;
  @observable route: FlightRoute = new FlightRoute();
  @observable time_from: any;
  @observable time_to: any;
  @observable is_time_range: boolean = false;
  @observable roundtrip: boolean = false;


  constructor(json?: any) {
    if(json) {
      this.first_name = json.first_name;
      this.last_name = json.last_name;
      this.email = json.email;
      this.phone = json.phone;
      this.note = json.note;
      this.aircraft_model = new Aircraft(json.aircraft_model);
      this.route = new FlightRoute(json.route);
      this.time_from = json.time_from ? moment(json.time_from) : null;
      this.time_to = json.time_to ? moment(json.time_to) : null;
      this.is_time_range = json.is_time_range;
      this.roundtrip = json.roundtrip;
    }
  }

  @action async send(): Promise<?string> {
    const backend = await BackendFactory();

    const res = await backend.post('/request', {
      ...mobx.toJS(this),
      time_from: this.time_from ? moment(this.time_from).utc().format('YYYY-MM-DD HH:mm:ss') : null,
      time_to: this.time_to ? moment(this.time_to).utc().format('YYYY-MM-DD HH:mm:ss') : null,
      aircraft_model: undefined,
      aircraft_model_id: this.aircraft_model ? this.aircraft_model.id : null
    });

    if(res.ok) {
      return res.data;
    }

    return null;
  }

  @computed get validEmail(): boolean {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(this.email);
  }

  @computed get validPhone(): boolean {
    var re = /^[+]?[0-9 ]{5,}$/;

    return re.test(this.phone);
  }

  @computed get validRoute(): boolean {
    return this.route.points.length > 1;
  }

  @computed get valid(): boolean {
    return this.validDate && this.first_name && this.last_name && this.email && this.validEmail && this.validRoute;
  }

  @computed get validDate(): boolean {
    if (!this.is_time_range) return Boolean(this.time_from && this.time_from.isValid());

    return Boolean(
      this.time_to && this.time_from &&
      this.time_to.isValid() && this.time_from.isValid() &&
      (
        this.time_from.isBefore(this.time_to) ||
        this.time_from.isSame(this.time_to)
      )
    );
  }

  @computed get pickUpPoint(): FlightRoutePoint {
    return this.route.points.length > 0? this.route.points[0] : null;
  }

  @computed get dropOffPoint(): FlightRoutePoint {
    if (this.roundtrip) return this.pickUpPoint;

    return this.route.points.length > 1? this.route.points[this.route.points.length-1] : null;
  }
}


// WEBPACK FOOTER //
// ./src/App/Store/FlightRequest/FlightRequestRequest.js